export const decorationCard = {
  type: `{room}室{hall}厅{toilet}卫 {area}㎡`,
  type1: `{room}室{hall}厅{toilet}卫·{area}㎡`,
  type2: `{room}室{hall}厅{kitchen}厨{toilet}卫·{area}㎡`,
  type3: `{room}室{hall}厅{kitchen}厨{toilet}卫·{area}㎡·{style}`
};
